import {
  PurchaseCreationDto,
  PurchaseDto,
  PurchaseUnitCreationDto,
  PurchaseUnitDto,
} from "../api";

export type PurchaseUnit = PurchaseUnitDto;

export type Purchase = PurchaseDto;

export type PurchaseCreation = PurchaseCreationDto;

export type PurchaseUnitCreation = PurchaseUnitCreationDto;

export const initialPurchase = (foodId: number): Purchase => {
  return {
    carbs: 0,
    description: "",
    fat: 0,
    foodId,
    id: 0,
    isDefault: false,
    availabilities: [],
    kcal: 0,
    protein: 0,
    purchaseUnits: [],
    purchaseRelevant: true,
    brand: "",
  };
};
